import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setFormStep } from "../../../../redux/slice/form";

import ImgStepArrow from "../../../../images/other/stepArrow.png";

import { classNames } from "primereact/utils";

const useFormStep = ({
  className = "",
  initActiveIndex = null,
  data = [],
} = {}) => {
  const dispatch = useDispatch();
  const [tabData, setTabData] = useState(data);
  const [activeIndex, setActiveIndex] = useState(initActiveIndex);

  useEffect(() => {
    setActiveIndex(initActiveIndex);
  }, [initActiveIndex]);

  useEffect(() => {
    if (tabData.length === 0 || activeIndex !== null) return;
    setActiveIndex(0);
  }, [tabData]);

  const onTabChange = ({ index } = {}) => {
    setActiveIndex(index);
    dispatch(setFormStep(index));
  };

  const renderTab = useCallback(
    ({ className = "" } = {}) => (
      <div className={classNames("grid align-items-center", className)}>
        {tabData.map((item, index) => (
          <React.Fragment key={`tab_${item.step}`}>
            <div
              className={classNames("col-5 sm:col-3 md:col text-center")}
              // onClick={() => onTabChange({ index: index })}
            >
              <div
                className={classNames(
                  "border-1 border-600 border-round-md p-1",
                  {
                    "text-white bg-blue-300": activeIndex === index,
                    "bg-gray-400": activeIndex !== index,
                  }
                )}
              >
                <div>步驟{index + 1}</div>
                <div className="text-xl mt-1">{item.label}</div>
              </div>
            </div>

            {index !== tabData.length - 1 && (
              <img className="w-2rem" src={ImgStepArrow} alt="step arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
    ),
    [tabData, activeIndex]
  );

  return {
    tabData,
    setTabData,
    activeIndex,
    setActiveIndex,
    onTabChange,
    renderTab,
  };
};

export default useFormStep;
